import Vue from 'vue'
import firebase from 'firebase/app'

const enable_status = ['auto-attach', 'manual-attach']
const state = {
	tabsRef: null,
	tabsUnsubscribe: null,
	editableRef: null,
	data: [],
	filterType: '',
	searchFieldValue: '',
	index: 20,
	has_more: true,
	is_loading: true,
	tabs: {},
	interval: {}
}

function toTab (doc) {
	const payload = {
		id: doc.id,
		title: doc.data().title,
		url: doc.data().url,
		type: doc.data().type,
		tags: doc.data().tags,
		query_tags: doc.data().query_tags,
		createdAt: doc.data().createdAt,
		updatedAt: doc.data().updatedAt,
		keywords: doc.data().keywords,
		og_image: doc.data().og_image,
		// description: doc.data().description,
		// innerText: doc.data().innerText,
		thumbnail_base64: doc.data().thumbnail_base64,
		thumbnail_url: doc.data().thumbnail_url,
	}
	return payload
}

const mutations = {
	set_index (state, payload) {
		state.index = payload
	},
	init (state, payload) {
		state.data = payload
	},
	set (state, payload) {
		Vue.set(state.tabs, [payload.id], payload)
	},
	remove (state, payload) {
		Vue.delete(state.tabs, payload.id)
	},
	updateSearchFieldValue (state, to) {
		state.searchFieldValue = to
	},
	update_index (state) {
		if (state.has_more) {
			const tmp = state.index + 20
			if (tmp < state.data.length) {
				state.index = tmp
			} else if (tmp > state.data.length && !state.is_loading) {
				state.index = tmp
				state.has_more = false
			}
		}
	},
	update_is_loading (state, to) {
		state.is_loading = to
	},
	reset_scroll (state) {
		state.index = 0
		state.has_more = true
	}
}
const getters = {
	data: (state) => {
		return state.data.sort((a, b) => {
			return (a.updatedAt < b.updatedAt ? 1 : -1)
		})
	},
	current_filtered_tabs: (state, getters) => {
		return getters.filtered_tabs(state.filterType)
	},
	filtered_tabs: (state) => (type) => {
		const tabs = Object.values(state.tabs)
		
		const res = tabs.sort((a, b) => {
			return (a.updatedAt < b.updatedAt ? 1 : -1)
		})
		.filter((tab) => {
			if (tab.type == 'trash') return false
			if (state.filterType == '') return true
			if (tab.type == type) return true
		})
		return res
	},
	tabs: (state, getters, rootState) => {
		const selected_tag = rootState.tags.selected
		let query_sub_tags_raw = JSON.parse(JSON.stringify(rootState.tags.query_sub_tags))
		const query_sub_tags = query_sub_tags_raw.concat(selected_tag)

		const res = getters.current_filtered_tabs
		.filter(tab => {
			if (selected_tag == '') return true

			const is_selected_tag = tab.tags.filter(tag => {
				// return tag.tag_id == selected_tag && enable_status.includes(tag.status)
				return query_sub_tags.includes(tag.tag_id) && enable_status.includes(tag.status)
			})
			if (is_selected_tag.length > 0) return true
			
			return false
		})
		// .slice(0, state.index)
		// .sort((a) => { // タグを含んでるのを上へ
		// 	if (selected_tag == '') return 1

		// 	const is_selected_tag = a.tags.filter(tag => {
		// 		return tag.tag_id == selected_tag && enable_status.includes(tag.status)
		// 	})
		// 	if (is_selected_tag.length > 0) return -1
			
		// 	return 1
		// })
		.sort((a, b) => {
			return (a.updatedAt < b.updatedAt ? 1 : -1)
		})
		
		return res
	},
	second_tabs: (state, getters, rootState) => {
		const selected_tag = rootState.tags.selected
		let query_sub_tags_raw = JSON.parse(JSON.stringify(rootState.tags.query_sub_tags))
		const query_sub_tags = query_sub_tags_raw.concat(selected_tag)

		if (selected_tag == '') {
			return []
		}
		const res = getters.filtered_tabs('deferred')
		.filter(tab => {
			if (selected_tag == '') return true

			const is_selected_tag = tab.tags.filter(tag => {
				// return tag.tag_id == selected_tag && enable_status.includes(tag.status)
				return query_sub_tags.includes(tag.tag_id) && enable_status.includes(tag.status)
			})
			if (is_selected_tag.length > 0) return true
			
			return false
		})
		.slice(0, state.index)
		.sort((a) => { // タグを含んでるのを上へ
			if (selected_tag == '') return 1

			const is_selected_tag = a.tags.filter(tag => {
				return tag.tag_id == selected_tag && enable_status.includes(tag.status)
			})
			if (is_selected_tag.length > 0) return -1
			
			return 1
		})
		
		return res
	},
	has_more: (state => state.has_more),
	filterType: (state => state.filterType),
}
const actions = {
	init ({ state, rootState }) {
		const uid = rootState.user.uid
		state.tabsRef = rootState.db.collection('users').doc(uid).collection('tabs').orderBy('updatedAt', 'desc')
		state.editableRef = rootState.db.collection('users').doc(uid).collection('tabs')
	},
	set_tabs_ref ({ rootState, state, dispatch }) {
		const uid = rootState.user.uid
		dispatch('rest_call')
		state.tabsRef = rootState.db
				.collection('users').doc(uid)
				.collection('tabs')
				.orderBy('updatedAt', 'desc')
		
		dispatch('startListener')
	},
	clear ({ commit }) {
		commit('init', [])
	},
	rest_call ({ rootState, dispatch }) {
		const start = new Date().getTime()
		firebase.auth().currentUser.getIdToken(true).then((id_token) => {
			// console.log('getToken', new Date().getTime() - start);
			const xhr = new XMLHttpRequest()
			const projectId = 'coral-web-ffcb8'
			const uid = rootState.user.uid
			const endpoint = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/users/${uid}/:runQuery`
			const limit = 20
			const query = {
                "structuredQuery": {
					"limit": limit,
					"from": [{"collectionId": "tabs"}],
					"orderBy": [
						{
							"field": {"fieldPath": "updatedAt"},
							"direction": "DESCENDING"
						}
					],
					"where": {
						"fieldFilter": {
							"field": {"fieldPath": "type"},
							"op": "EQUAL",
							"value": {"stringValue": "inbox"}
						}
					}
				}
			}
			xhr.open('POST', endpoint)
			xhr.setRequestHeader("Content-Type", "application/json");
			const auth_data = `Bearer ${id_token}`
			xhr.setRequestHeader("Authorization", auth_data);
			xhr.onload = () => {
				// console.log('xhr.status',xhr.status)
				// console.log(xhr.response)
				// console.log('res', new Date().getTime() - start);
				dispatch('parse_rest_response', xhr.response)
			}
			xhr.onerror = () => {
				console.log("error!")
			}
			xhr.send(JSON.stringify(query))
		})
	},
	parse_rest_response ({ commit }, res) {
		JSON.parse(res).map(item => {
			let doc = {}
			const document = item['document']
			doc['id'] = document["name"].split('/').slice(-1)[0]
			const fields = document['fields']

			const str_fields = ["title", "url", "description", "type", "og_image", "thumbnail_base64", "innerText", "unread_type"]
			str_fields.forEach(key => {
				if (fields[key]) {
					const value = fields[key]['stringValue']
					doc[key] = value
				}
			})

			const int_fields = ["deferredUntil", "createdAt", "updatedAt"]
			int_fields.forEach(key => {
				if (fields[key]) {
					const value = fields[key]['integerValue']
					doc[key] = Number(value)
				}
			})

			const bool_fields = ["pinned"]
			bool_fields.forEach(key => {
				if (fields[key]) {
					const value = fields[key]['booleanValue']
					doc[key] = value
				}
			})

			doc['tags'] = fields["tags"]["arrayValue"]["values"].map(val => {
				let tag = {}
				const mapValue = val["mapValue"]['fields']
				if (mapValue["status"]) {
					tag["status"] = mapValue["status"]['stringValue']
				}
				if (mapValue["name"]) {
					tag["name"] = mapValue["name"]['stringValue']
				}
				if (mapValue["source"]) {
					tag["source"] = mapValue["source"]['stringValue']
				}
				if (mapValue["tag_id"]) {
					tag["tag_id"] = mapValue["tag_id"]['stringValue']
				}
				if (mapValue["admin_tag_id"]) {
					tag["admin_tag_id"] = mapValue["admin_tag_id"]['stringValue']
				}
				return tag
			})

			commit('set', doc)
		})
	},
	setFilterType ({state, getters, commit}, type) {
		if (type !== 'inbox' && type !== 'done' && type !== 'deferred') {
			return
		}
		commit('set_index', 20)
		state.filterType = type

		clearInterval(state.interval)
		state.interval = setInterval(function() {
			if (state.index - 20 <= getters.current_filtered_tabs.length) {
				// commit('set_index', state.index + 20)
				commit('set_index', getters.current_filtered_tabs.length)
			} else {
				clearInterval(state.interval)
			}
		}, 2000)
	},
	// 1. リスナーの起動
	startListener ({ dispatch, commit, state }) {
		dispatch('stopListener')
		commit('update_is_loading', true)
		if (state.tabsUnsubscribe) {
			state.tabsUnsubscribe()
			state.tabsUnsubscribe = null
		}
		state.tabsUnsubscribe = state.tabsRef.onSnapshot(querySnapshot => {
			commit('update_is_loading', false)
			querySnapshot.docChanges().forEach(change => {
				const payload = toTab(change.doc)
				if (change.type === 'added') {
					if (payload.type === 'trash') return
					commit('set', payload)
				} else if (change.type === 'modified') {
					commit('set', payload)
				} else if (change.type === 'removed') {
					commit('remove', payload)
				}
			})
		},
		(error) => {
			commit('update_is_loading', false)
		})
	},
	// 8. リスナーの停止
	stopListener () {
		if (state.tabsUnsubscribe) {
			state.tabsUnsubscribe()
			state.tabsUnsubscribe = null
		}
	},
	setType ({ state }, payload) {
		const ref = state.editableRef
		const newItem = {
			type: payload.to,
			updatedAt: new Date().getTime()
		}
		ref.doc(payload.id).update(newItem)
			.then(() => {

			})
	},
}
export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
}
